/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum GetCustomsOfficesResult {
  Error = 0,
  Success = 1,
  InternalServerError = 2,
}
